import React from 'react';
import { TextInput } from '@ncr-retail/base-retail-components';
import { Grid, Typography } from '@material-ui/core';
import { transactionSearchModalStyles } from '../transaction-based-return-styles';
import { useTranslation } from 'react-i18next';

const SearchParameterInput: React.FC<ISearchParameterInputProps> = (
  props: ISearchParameterInputProps,
): JSX.Element => {
  const classes = transactionSearchModalStyles();
  const { onChange, dataTestIdPrefix, name, value, label, index } = props;
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={4} className={`${classes.labelHeadTop} ${classes.rowPaddingTop}`}>
        <Typography className={classes.labelHead}>{label}</Typography>
      </Grid>
      <Grid item xs={8} className={classes.rowPaddingTop}>
        <Grid item>
          <TextInput
            name={name}
            type={'standard'}
            value={value}
            onChange={onChange}
            placeholder={t('Enter Number')}
            autoComplete='off'
            className={classes.inputText}
            inputProps={{
              'data-testid': `${dataTestIdPrefix}-input-field`,
              'data-keyboard-owner': `${name}-focus`,
              'data-id': index,
              className: 'global-keyboard',
              'data-custombuttons': 'keyboardWithSearchButton',
            }}
            id={name}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default SearchParameterInput;

export interface ISearchParameterInputProps {
  onChange: (e) => void;
  dataTestIdPrefix: string;
  name: string;
  value: string;
  label: string;
  index?: number;
}
